import { STRINGS } from '../../constants';
import filterEmptyParams from '../../utils/filters';
import apiCaller from '../http';
import URLS from '../urls';

const rejectVisit = async (visitId, data, setError, goBack, refreshVisitDetail, logoutHandler) => {
  const payload = {
    first_proposition: data.firstProposition,
    second_proposition: data.secondProposition,
    rejection_reason: data.reason,
  };

  await apiCaller
    .put(`${URLS.VISIT_REJECT}${visitId}/`, filterEmptyParams(payload))
    .then(() => {
      setError(null);
      refreshVisitDetail();
      goBack(false);
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default rejectVisit;
